import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  dropzone: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 70,
    borderWidth: 1,
    borderStyle: 'dashed',
    borderColor: theme.palette.grey[300],
    borderRadius: 10,
    cursor: 'pointer',
    userSelect: 'none',
    transition: theme.transitions.create('border', {
      duration: theme.transitions.duration.shortest,
    }),

    '&.isDragActive, &.isFileDialogActive': {
      borderWidth: 2,
      borderStyle: 'solid',
      borderColor: theme.palette.secondary.main,
    },

    '&.hasError': {
      borderColor: theme.palette.error.main + '!important',
      color: theme.palette.error.main + '!important',
    },
  },
}));
